import PortalStudentProfile from '@classes/StudentProfile'
import { StoreProps } from '@interfaces/StoreState'
import ProgramSelector from '@layouts/Dashboard/HeroBlock/ProgramSelector'
import { updateDashboardActiveMaterial } from '@redux/actions/dashboard'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/**
 * This is a wrapper component that will help to initialize the active material
 * on page load. This is needed because the active material usually get data
 * from local storage and sometimes its not what we want to show on initial page load.
 *
 */
const HeroBlockInitializer = ({ children }) => {
  const dispatch = useDispatch()
  const { portalStudentInfo, activeMaterial } = useSelector(({ userProfile, dashboard }: StoreProps) => {
    const portalStudentInfo = userProfile?.info?.StudentProfile?.StudentProfileInfo
      ? new PortalStudentProfile(userProfile?.info?.StudentProfile?.StudentProfileInfo)
      : {
          MaterialDropDown: [],
          getActiveLPIdFromMaterialDropdown: () => '',
          storeActiveDropdownLPId: () => '',
        }
    return {
      portalStudentInfo,
      activeMaterial: dashboard.activeMaterial,
    }
  })

  /**
   * If it has activeMaterial then it means that the user has selected a material in program selector
   * therfore we use it as an active selected material otherwise we use the active material from the getActiveLPIdFromMaterialDropdown
   */
  const selectedMaterial = activeMaterial || portalStudentInfo?.getActiveLPIdFromMaterialDropdown()

  useEffect(() => {
    if (!activeMaterial && selectedMaterial) {
      dispatch(updateDashboardActiveMaterial(selectedMaterial))
    }
  }, [])

  useEffect(() => {
    if (selectedMaterial) {
      portalStudentInfo?.storeActiveDropdownLPId(selectedMaterial)
    }
  }, [selectedMaterial])

  return (
    <>
      <ProgramSelector showCT defaultProgram={selectedMaterial} hide />
      {<>{children}</>}
    </>
  )
}

export default HeroBlockInitializer
